<template>
  <div class="container py-5">
    <div class="row justify-content-center">
      <div class="col-lg-8">
        <h1 class="mb-4">{{ t('pages./about.title') }}</h1>
        <p class="about-lead">{{ t('pages./about.lead') }}</p>

        <h2 class="about-heading">{{ t('pages./about.why-title') }}</h2>
        <p class="about-body">{{ t('pages./about.why-body') }}</p>

        <h2 class="about-heading">{{ t('pages./about.how-title') }}</h2>
        <p class="about-body">{{ t('pages./about.how-body') }}</p>

        <h2 class="about-heading">{{ t('pages./about.who-title') }}</h2>
        <p class="about-body">
          {{ t('pages./about.who-body') }}
          <a :href="commercePath">{{ t('pages./about.who-link') }}</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'

const { t } = useI18n()
const route = useRoute()

const commercePath = computed(() => {
  const lang = route.params.lang as string | undefined
  return lang ? `/${lang}/commerce` : '/commerce'
})
</script>

<style scoped>
.about-lead {
  font-size: 1.15rem;
  line-height: 1.9;
  color: #212529;
  margin-bottom: 2.5rem;
}

.about-heading {
  font-size: 1.2rem;
  font-weight: 700;
  margin-top: 2.5rem;
  margin-bottom: 0.75rem;
}

.about-body {
  line-height: 1.9;
  color: #495057;
  margin-bottom: 0;
}
</style>
